import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const AdminTopNavLinks = ({
  children,
  destination,
  menuCallback = null,
  endPage = true,
}) => {
  return (
    <li className='duration-300 hover:text-primary-700'>
      <NavLink
        className={({ isActive }) =>
          isActive
            ? 'adminNavMenu mx-5 border-b-2 border-primary-700 font-bold'
            : 'adminNavMenu mx-5'
        }
        to={destination}
        onClick={menuCallback}
        end={endPage}
      >
        {children}
      </NavLink>
    </li>
  );
};

AdminTopNavLinks.propTypes = {
  children: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  menuCallback: PropTypes.func,
};
export default AdminTopNavLinks;
